module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/events-calculator/venue/venue.component.css
// module id = ./src/app/components/calculator/calculator-item/events-calculator/venue/venue.component.css
// module chunks = main